<template>
  <div class="modal fade createNewModal" id="addBlacklistModal" tabindex="-1" ref="addBlacklistModalRef"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header d-block ps-0 pe-0 pt-0 pb-15 pb-md-25">
          <h5 class="modal-title fw-bold text-black">{{ title }}</h5>
        </div>

        <div class="modal-body ps-0 pe-0 pb-0 pt-15 pt-md-25">
          <Form ref="formRef" @submit="submitForm" :validation-schema="schema">
            <div class="row">

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Code <span class="text-danger">*</span>
                  </label>
                  <Field name="list_code" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Code de la liste réglementaire" />
                  <ErrorMessage name="list_code" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Type d'élément visé <span class="text-danger">*</span>
                  </label>
                  <Field name="entry_type" v-slot="{ field, setValue }">
                    <Multiselect 
                      :searchable="true"
                      track-by="value" 
                      label="label"
                      v-bind="field"  
                      :options="entryTypeOptions"
                      @update:model-value="(val) => { 
                        setValue(val);
                        selectedEntryType = (typeof val === 'object' ? val?.value : val) || null;
                      }"
                      placeholder="Entrer le Type d'élément visé" />
                  </Field>
                  <ErrorMessage name="entry_type" class="text-danger" />
                </div>
              </div>

             <div class="col-md-6" v-if="selectedEntryType === 'PERSON'">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">Acteur</label>
                  <Multiselect 
                    :searchable="true"
                    track-by="value" 
                    label="label"
                    :object="true"
                    :options="acteursOptions"
                    placeholder="Sélectionner un acteur"
                    @update:model-value="(val) => {
                      console.log('VAL refffff SELECTIONNE:', val);       
                      console.log('refffffActeur:', val?.refActeur);           
                      formRef?.setFieldValue('reference_value', val?.refActeur || String(val?.value || ''));
                    }"/>
                </div>
              </div>
              <!-- Champ conditionnel: Organisation -->
              <div class="col-md-6" v-if="selectedEntryType === 'ORGANIZATION'">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Organisation <span class="text-danger">*</span>
                  </label>
                  <Field name="reference_value" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Nom de l'organisation" />
                  <ErrorMessage name="reference_value" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6" v-if="selectedEntryType === 'COUNTRY'">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Pays <span class="text-danger">*</span>
                  </label>
                  <Multiselect 
                    :searchable="true"
                    track-by="value" 
                    label="label"
                    :object="true"
                    :options="pays"
                    placeholder="Sélectionner un pays" 
                    @update:model-value="(val) => {
                      console.log('VAL isooooo SELECTIONNE:', val);       
                      console.log('isoooo:', val?.iso2_code);              
                      formRef?.setFieldValue('reference_value', val?.iso2_code || '');
                    }"/>
                </div>
              </div>

              <div class="col-md-6" v-if="selectedEntryType === 'PORT'">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">Port</label>
                  <Multiselect 
                    :options="ports" 
                    :searchable="true" 
                    :loading="loadingPorts"
                    placeholder="Rechercher (nomPort ou locode)..." 
                    label="label" 
                    track-by="value"
                    :object="true"
                    @search-change="searchPort" 
                    :filter-results="false" 
                    :min-chars="2"
                    @update:model-value="(val) => {
                      console.log('VAL locode SELECTIONNE:', val);       
                      console.log('locodeee:', val?.locode);
                      formRef?.setFieldValue('reference_value', val?.locode || '');
                    }"/>
                </div>
              </div>

             <div class="col-md-6" v-if="selectedEntryType === 'SHIP'">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">Navire</label>
                  <Multiselect 
                    :options="navires" 
                    :searchable="true" 
                    :loading="loadingNavires"
                    placeholder="Rechercher (nom, MMSI ou IMO)..." 
                    label="label" 
                    track-by="value"
                    :object="true"
                    @search-change="searchNavire" 
                    :filter-results="false" 
                    :min-chars="2"
                    @update:model-value="(val) => {
                      console.log('VAL imoooo SELECTIONNE:', val);       
                      console.log('imoooo:', val?.imo);
                      formRef?.setFieldValue('reference_value', val?.imo || '');
                    }"/>
                </div>
              </div>

                  <div class="col-md-6" v-if="selectedEntryType && selectedEntryType !== 'ORGANIZATION'">
                    <div class="form-group mb-15 mb-sm-20 mb-md-25">
                      <label class="d-block text-black fw-semibold mb-10">
                        Référence <span class="text-danger">*</span>
                      </label>
                      <Field name="reference_value" type="text" 
                        class="form-control shadow-none fs-md-15 text-black bg-light" 
                        readonly
                        :placeholder="referencePlaceholder" />
                      <ErrorMessage name="reference_value" class="text-danger" />
                    </div>
                  </div>
             
              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Raison <span class="text-danger">*</span>
                  </label>
                  <Field name="reason" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer la raison ou contexte de l'inscription sur la liste" />
                  <ErrorMessage name="reason" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Niveau de risque associé <span class="text-danger">*</span>
                  </label>
                  <Field name="risk_level" v-slot="{ field }">
                    <Multiselect :searchable="true"
                      track-by="value" 
                      label="label"
                      v-bind="field" 
                       :options="niveauOptions"
                      placeholder="Sélectionner le niveau de risque" />
                  </Field>

                  <ErrorMessage name="risk_level" class="text-danger" />
                </div>
              </div>              

              <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Autorité ou source <span class="text-danger">*</span>
                  </label>
                  <Field name="source_authority" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'autorité" />
                  <ErrorMessage name="source_authority" class="text-danger" />
                </div>
              </div>
               <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Identifiants supplémentaires
                  </label>
                  <Field name="additional_identifiers" as="textarea"
                    class="form-control shadow-none fs-md-15 text-black" rows="4"
                    placeholder='{"alias": ["ABC Corp"], "registration_number": "12345"}' />
                  <ErrorMessage name="additional_identifiers" class="text-danger" />
                </div>
              </div>


              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date d'entrée en vigueur de l'inscription
                  </label>
                  <Field name="effective_from" type="date" class="form-control shadow-none fs-md-15 text-black" />
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de fin de validité éventuelle.
                  </label>
                  <Field name="effective_to" type="date" class="form-control shadow-none fs-md-15 text-black" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">Activer</label> <span class="text-danger">*</span>
                  <Field name="is_active" type="checkbox" class="form-check-input" :value="true"
                    :unchecked-value="false" />
                </div>
              </div>

              <button
                class="default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16"
                type="submit">
                {{ btntext }}
              </button>

            </div>
          </Form>
        </div>

        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
          @click="resetValue()">
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, ref, watch, onMounted, computed } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import ApiService from "../../services/ApiService";
import * as Yup from "yup";
import { error, success, hideModal } from "../../utils/utils";
import { RegulatoryBlacklists } from "@/models/RegulatoryBlacklists";
import Multiselect from "@vueform/multiselect";

export default defineComponent({
  name: "addBlacklistModal",
  components: {
    Form, Field, ErrorMessage,
    Multiselect
  },

  props: {
    item: {
      type: Number,
      default: 0,
    },
  },

  setup(props, { emit }) {
    const schema = Yup.object().shape({
      list_code: Yup.string().required("Le Code de la liste réglementaire  est obligatoire"),
      reference_value: Yup.string().required("La Valeur principale servant à la correspondance est obligatoire"),
      entry_type: Yup.string().required("Type d'élément visé  est obligatoire"),
      reason: Yup.string().required("Raison ou contexte de l'inscription sur la liste  est obligatoire"),
      source_authority: Yup.string().required("L'Autorité ou la source ayant fourni ou validé cette entrée est obligatoire"),
      risk_level: Yup.string().required("Le Niveau de risque associé est obligatoire"),
      additional_identifiers: Yup.string().nullable(),
       is_active: Yup.boolean().nullable(),
      effective_from: Yup.date().nullable(),
      effective_to: Yup.date().nullable(),
    });

    const formRef = ref<RegulatoryBlacklists | null>(null);
    const addBlacklistModalRef = ref<HTMLElement | null>(null);
    const isUPDATE = ref(false);
    const title = ref("Ajouter une Blacklist");
    const btntext = ref("Ajouter");
    const entry_type = ref(null);
    const list_code = ref(null);
    const risk_level = ref(null);
    const acteursOptions = ref([]);
    const pays = ref([]);
    const ports = ref<Array<{ label: string; value: number }>>([]);
    const navires = ref<Array<{ label: string; value: number }>>([]);
    const loadingPorts = ref(false);
    const loadingNavires = ref(false);
    const selectedEntryType = ref<string | null>(null);
    let searchTimeout: ReturnType<typeof setTimeout> | null = null;
      const referenceValue = ref('');


    const niveauOptions = [
      { value: 'HIGH', label: 'Élevé' },
      { value: 'MEDIUM', label: 'Moyen' },
      { value: 'LOW', label: 'Faible' }
    ];

    const listCodeOptions = [
      { value: 'NATIONAL_BLACKLIST', label: 'Liste noire nationale' },
      { value: 'UN_SANCTIONS', label: 'Sanctions ONU' },
      { value: 'REGIONAL_ALERT_LIST', label: 'Liste régionale de vigilance' },
    ];

    const entryTypeOptions = [
      { value: 'ORGANIZATION', label: 'Organisation' },
      { value: 'PERSON', label: 'Personne physique' },
      { value: 'SHIP', label: 'Navire' },
      { value: 'COUNTRY', label: 'Pays' },
      { value: 'PORT', label: 'Port' },
    ];


    watch(
      () => props.item,
      (id) => {
        if (id) {
          getItem(id);
          isUPDATE.value = true;
          setTitles();
        }
      }
    );

    const setTitles = () => {
      if (isUPDATE.value) {
        title.value = "Modifier la Blacklist";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter une Blacklist";
        btntext.value = "Ajouter";
      }
    };


   

    const referencePlaceholder = computed(() => {
      switch (selectedEntryType.value) {
        case 'PORT': return 'Locode du port (auto)';
        case 'SHIP': return 'IMO du navire (auto)';
        case 'PERSON': return 'Référence acteur (auto)';
        case 'COUNTRY': return 'Code du pays (auto)';
        default: return '';
      }
    });
    const getItem = async (id: number) => {
      ApiService.get("/regulatory/" + id)
        .then(({ data }) => {
          const d = data.data;
          for (const key in d) {
            formRef.value?.setFieldValue(key, d[key]);
          }
          if (d.entry_type) {
            selectedEntryType.value = d.entry_type.value || d.entry_type;
          }
          emit("openmodal", addBlacklistModalRef.value);
        })
        .catch(({ response }) => error(response.data.message));
    };

    const fetchActeurs = async () => {
      try {
        const response = await ApiService.get('/acteurs');
        const acteurData = response.data.data.data;
        console.log("testtttttt",acteurData);
        acteursOptions.value = acteurData.map((acteur: any) => ({
          value: acteur.id,
          label: `${acteur.nomComplet}`,
          refActeur: acteur.refActeur
        }));
      } catch (err) {
        console.error('Erreur fetchActeurs:', err);
      }
    };

    const fetchPays = async () => {
      try {
        const { data } = await ApiService.get("/pays");
        console.log("payssssssssssiicc",data);

        pays.value = data.data.data.map((p: any) => ({
          label: p.name_fr,
          value: p.id,
          iso2_code: p.iso2_code 
        }));
      } catch (err) {
        console.error('Erreur fetchPays:', err);
      }
    };

    const searchPort = async (query: string) => {
      if (searchTimeout) clearTimeout(searchTimeout);
      
      if (!query || query.length < 2) {
        ports.value = [];
        return;
      }

      searchTimeout = setTimeout(async () => {
        loadingPorts.value = true;
        try {
          const response = await ApiService.get(`/Liste/port?search=${encodeURIComponent(query)}`);
          const portsData = response.data?.data || [];

          ports.value = portsData.map((port: any) => ({
            label: `${port.nomPort} - ${port.locode}`,
            value: port.id,
             locode: port.locode,
            codePays: port.codePays
          }));
        } catch (err: any) {
          console.error('Erreur recherche ports:', err);
          error('Impossible de rechercher les ports');
          ports.value = [];
        } finally {
          loadingPorts.value = false;
        }
      }, 300);
    };

    const searchNavire = async (query: string) => {
      if (searchTimeout) clearTimeout(searchTimeout);

      if (!query || query.length < 2) {
        navires.value = [];
        return;
      }

      searchTimeout = setTimeout(async () => {
        loadingNavires.value = true;
        try {
          const response = await ApiService.get(`/vessels?search=${encodeURIComponent(query)}`);
          const naviresData = response.data?.data || [];
          console.log("navireeeeeeee",naviresData);
          navires.value = naviresData.map((navire: any) => ({
            label: `${navire.name} - ${navire.mmsi} - ${navire.imo}`,
            value: navire.id,
            imo: navire.imo
          }));
        } catch (err: any) {
          console.error('Erreur recherche navires:', err);
          error('Impossible de rechercher les navires');
          navires.value = [];
        } finally {
          loadingNavires.value = false;
        }
      }, 300);
    };

    watch(selectedEntryType, (newType) => {
      if (newType === 'COUNTRY' && pays.value.length === 0) {
        fetchPays();
      } else if (newType === 'PERSON' && acteursOptions.value.length === 0) {
        fetchActeurs();
      }
    });

    const submitForm = async (values: any, { resetForm }) => {
      if (isUPDATE.value) {
        ApiService.put("/regulatory/" + values.id, values)
          .then(({ data }) => {
            success(data.message);
            resetForm();
            hideModal(addBlacklistModalRef.value);
            isUPDATE.value = false;
            setTitles();
            emit("close");
          })
          .catch(({ response }) => error(response.data.message));
      } else {
        ApiService.post("/regulatory", values)
          .then(({ data }) => {
            success(data.message);
            resetForm();
            hideModal(addBlacklistModalRef.value);
            emit("close");
          })
          .catch(({ response }) => error(response.data.message));
      }
    };

    const resetValue = () => {
      const fields = document.querySelectorAll("input, select, textarea");
      isUPDATE.value = false;
      selectedEntryType.value = null;
      fields.forEach((el: any) => (el.value = ""));
      setTitles();
    };

    onMounted(() => {
      fetchActeurs();
      fetchPays();
    });

    return {
      schema,
      addBlacklistModalRef,
      formRef,
      submitForm,
      resetValue,
      title,
      btntext,
      niveauOptions, 
      risk_level,
      entry_type, 
      list_code,
      listCodeOptions, 
      entryTypeOptions,
      fetchActeurs,
      acteursOptions,
      pays,
      ports,
      navires,
      loadingPorts,
      loadingNavires,
      selectedEntryType,
      searchPort,
      searchNavire,
      referenceValue,referencePlaceholder
    };
  },
});
</script>
